export default __webpack_public_path__ + "static/media/contact.09c9e66c.png";